module.exports = {"513228100":"芦花镇","513228101":"卡龙镇","513228102":"色尔古镇","513228103":"西尔镇","513228104":"木苏镇","513228105":"沙石多镇","513228106":"知木林镇","513228107":"扎窝镇","513228204":"瓦钵梁子乡","513228206":"石碉楼乡","513228207":"龙坝乡","513228208":"洛多乡","513228210":"维古乡","513228213":"晴朗乡","513228214":"慈坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513228.json
// module id = 2537
// module chunks = 0